export const PRICING_ROUTE = Object.freeze({
    BUSINESS_API: 'Pricing',
    INDIVIDUAL_REPORTS: 'PricingReports',
    CHECKOUT: 'Checkout',
});
